import historyProvider from './historyProvider'
import Stream from './stream'
import $store from '@/store/index'
import Data from '@/util/data'
import constants from '@/util/constants'
import Util from '@/util/util'

const supportedResolutions = [
  '1',
  '5',
  '15',
  '30',
  '60',
  '240',
  '360',
  'D',
  'W',
  'M'
]

const config = {
  supported_resolutions: supportedResolutions,
  exchanges: [
    {
      value: 'BINANCE',
      name: 'Binance',
      desc: 'Binance'
    },
    {
      value: 'FUTURES',
      name: 'Futures',
      desc: 'Futures'
    },
    {
      value: 'HUOBI',
      name: 'Huobi',
      desc: 'Huobi'
    },
    {
      value: 'FTX',
      name: 'FTX',
      desc: 'FTX'
    },
    {
      value: 'OKX',
      name: 'OKX',
      desc: 'OKX'
    }
  ]
}

function getKeyByValue (object, value) {
  return Object.keys(object).find(key => object[key] === value)
}

const TStream = new Stream('T')
const searchResult = []

export default {
  onReady: cb => {
    // console.log('=====onReady running')
    setTimeout(() => cb(config))
  },
  searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
    // console.log('====Search Symbols running', userInput, exchange, symbolType)

    const exchangeKey = getKeyByValue(constants.exchangeTVIds, exchange) || 'BIN'
    const symbols = $store.state.data.allSymbols[exchangeKey] || []
    searchResult.length = 0

    symbols.forEach(symbol => {
      const pair = `${symbol.baseAsset}/${symbol.quoteAsset}`
      const index = pair.indexOf(userInput.toUpperCase())

      if (index !== -1) {
        searchResult.push({
          symbol: pair,
          full_name: `${exchange}:${pair}`,
          description: '',
          exchange,
          type: 'crypto',
          searchIndex: index
        })
      }
    })

    searchResult.sort((a, b) => a.searchIndex - b.searchIndex)

    onResultReadyCallback(searchResult)
  },
  resolveSymbol: (
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback
  ) => {
    // console.log('resolveSymbol:', symbolName)
    let splitData = symbolName.split(/[:/]/)

    if (splitData.length < 3 && searchResult.length) {
      symbolName = searchResult[0].full_name
      splitData = symbolName.split(/[:/]/)
    }

    const symb1 = splitData[1] + '_' + splitData[2]
    let priceDec = 8
    if ($store.state.data.symbolsfilter[symb1]) {
      priceDec = $store.state.data.symbolsfilter[symb1].PriceDec
    } else if (symb1 === 'BTC_USDT' || symb1 === 'ETH_USDT') {
      priceDec = 2
    }

    // expects a symbolInfo object in response
    // console.log('======resolveSymbol running')
    // console.log('resolveSymbol:', symbolName, symb1)
    // console.log('priceDec:', priceDec)

    // console.log({split_data})
    const symbolStub = {
      // name: symbolName,
      name: splitData[1] + '/' + splitData[2],
      // pro_name: splitData[1] + '/' + splitData[2],
      // full_name: splitData[0] + ':' + splitData[1] + '/' + splitData[2],
      description: splitData[1] + '/' + splitData[2],
      type: 'crypto',
      session: '24x7',
      timezone: 'Etc/UTC',
      ticker: splitData[0] + ':' + splitData[1] + '/' + splitData[2],
      exchange: splitData[0],
      minmov: 1,
      pricescale: Math.pow(10, priceDec),
      has_intraday: true,
      intraday_multipliers: ['1', '5', '15', '30', '60', '240', '360'],
      supported_resolution: supportedResolutions,
      supports_time: true,
      has_daily: true,
      has_weekly_and_monthly: true,
      volume_precision: 8,
      data_status: 'streaming'
    }

    if (splitData[0] === 'FTX') {
      symbolStub.intraday_multipliers = ['1', '5', '15', '60', '240']
      symbolStub.has_weekly_and_monthly = false
    }

    // if (split_data[2].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY/)) {
    //   symbol_stub.pricescale = 100
    // }

    setTimeout(() => onSymbolResolvedCallback(symbolStub))

    // onResolveErrorCallback('Not feeling it today')
  },
  getBars: function (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback
  ) {
    const { from, to, firstDataRequest } = periodParams
    // console.log('=====getBars running. interval:', resolution, ' from:', new Date(from * 1000), ' to:', new Date(to * 1000), ' first:', firstDataRequest)
    // console.log('ft', from, to)
    // console.log('get bars:', symbolInfo.full_name)
    // console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
    historyProvider
      .getBars(
        'term',
        symbolInfo,
        resolution,
        from * 1000,
        to * 1000,
        firstDataRequest
      )
      .then(bars => {
        if (bars.length) {
          onHistoryCallback(bars, { noData: false })
        } else {
          onHistoryCallback(bars, { noData: true })
        }
      })
      .catch(err => {
        console.log(err)
        onErrorCallback(err)
      })
  },
  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscribeUID,
    onResetCacheNeededCallback
  ) => {
    // console.log('=====subscribeBars runnning')
    // console.log('subscribeBars:', symbolInfo.full_name, resolution)
    Data.resetCacheTerm = onResetCacheNeededCallback
    TStream.subscribeBars(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback
    )
    // stream.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback)
  },
  unsubscribeBars: subscriberUID => {
    // console.log('=====unsubscribeBars running')
    TStream.unsubscribeBars(subscriberUID)
    // stream.unsubscribeBars(subscriberUID)
  },
  calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
    return historyProvider.historyDepth(
      resolution,
      resolutionBack,
      intervalBack
    )
  },
  getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
    // optional
    // console.log('=====getMarks running', endDate)
    // var mark = {
    //   id: '12345',
    //   time: (endDate - 900000),
    //   color: 'red',
    //   text: 'hello',
    //   label: 'B',
    //   labelFontColor: 'black',
    //   minSize: 10
    // }
    // onDataCallback([mark])
  },
  getTimeScaleMarks: (
    symbolInfo,
    startDate,
    endDate,
    onDataCallback,
    resolution
  ) => {
    // optional
    // console.log('=====getTimeScaleMarks running')

    const mark = {
      id: '12345',
      time: endDate,
      color: 'red',
      text: 'hello',
      label: 'B',
      labelFontColor: 'black',
      minSize: 5
    }

    onDataCallback([mark])
  },
  getServerTime: cb => {
    setTimeout(() => cb(Math.floor(Date.now() / 1000)))
  }
}
